import { defineStore } from "pinia";
import { IDevice } from "../../models/Devices/device";
import { useDeviceStore } from "../device.store";
import { useParameterStore } from "../parameter.store";
import { DeviceTypes } from "../../constantes/constants";
import { useManufactoringProductionStore } from "../manufactoringProduction.store";
import ManufactoringProductionServices from "../../services/ManufactoringProductionService";
import DispatchManufactoringServices from "../../services/DispatchManufactoringService";
import { useDevicePropertyStore } from "../deviceProperty.store";
import { useLotStore } from "../lot.store";
import { useUsersStore } from "../users.store";
import IDeviceProperty from "../../models/Devices/deviceProperty";
import { IFTPHeterospermyRequestInfo } from "../../models/Devices/ftpHeterospermyRequestInfo";

export const useRQStore = defineStore('rq', {
    state: () => ({
        selectedRQId: 0 as number,
        selectedRQProperties: [] as IDeviceProperty[],

        availableRQs: [] as IDevice[]
    }),
    getters: {
        hasActiveRQ(state) {
            return state.selectedRQId != 0;
        },

        selectedRQ(state) {
            return state.availableRQs.find(rq => rq.id == state.selectedRQId);
        }
    },
    actions: {
        init() {
            this.availableRQs = [];

            const deviceStore = useDeviceStore();
            const paramStore = useParameterStore();

            let rqTypeId = paramStore.getParameterByCode3('DEVICE', 'TYPE', DeviceTypes.RQ800)?.id;
            this.availableRQs = deviceStore.getDeviceByTypeForCurrentCenter(rqTypeId!);

            if(this.availableRQs.length > 0) {
                this.selectedRQId = this.availableRQs[0].id;

                const devicePropertyStore = useDevicePropertyStore();
                devicePropertyStore.currentDeviceId = this.selectedRQId;
                this.selectedRQProperties = devicePropertyStore.getCurrentDeviceProperties;
            }
        },

        /**
         * Envoie les données de fabrication à déposer sur le FTP du RQ800
         * @param isDailyBase Indicateur d'envoi de base du jour ou base globale
         */
        async sendMonoData(isDailyBase: boolean = true) {
            if(this.hasActiveRQ) {
                const deviceStore = useDeviceStore();
                const manufactureStore = useManufactoringProductionStore();
    
                // await + reload si datas scopé par date (loadedDateFrom défini) : sinon le set
                // est partiel et l'envoi (base du jour comme base globale) écrase la base machine.
                if(manufactureStore.datas.length == 0 || manufactureStore.loadedDateFrom !== undefined)
                    await manufactureStore.load({ page: 1, pageSize: 0, include: "*" });
        
                let contextualManufactures = isDailyBase ? manufactureStore.todayAndYesterdayManufactures : manufactureStore.datas;
        
                let manPDTOList = contextualManufactures.map(man => {
                    return ManufactoringProductionServices.toDTO(manufactureStore.toForm(man));
                });
        
                await deviceStore.sendMonospermyBytesToFTPDevice(this.selectedRQId, manPDTOList, isDailyBase);
            }
            else {
                console.error("No RQ800 device found to process the request");
            }
        },

        async sendHeteroData() {
            if(this.hasActiveRQ) {
                const deviceStore = useDeviceStore();
                const lotStore = useLotStore();
                const centerId = useUsersStore().currentCenter?.id;

                // Recharger le set complet si vide, autre centre, OU si datas a été chargé
                // en mode scopé par date (loadEjaculateData → loadedDateFrom défini) : sinon
                // todayAndYesterdayLot est partiel et l'envoi écrase les lots précédents sur la machine.
                if (lotStore.datas.length === 0 || lotStore.loadedCenterId !== centerId || lotStore.loadedDateFrom !== undefined)
                    await lotStore.load({ page: 1, pageSize: 0, centerId, include: '*' }, centerId);

                let requestInfos: IFTPHeterospermyRequestInfo[] = [];
                let mfProds = lotStore.todayAndYesterdayLot;

                // Résoudre les animaux côté serveur via lot-composition
                // (évite la chaîne d'hydratation fragile dispatch → parent → manufactoringProduction → production → animal)
                const compositionPromises = mfProds.map(lot =>
                    DispatchManufactoringServices.getLotComposition(lot.id).then(result => ({
                        lotId: lot.id,
                        boarsTattooNumbers: !result.error && result.data
                            ? result.data.boars.map(b => b.tattooIdentification)
                            : []
                    }))
                );
                requestInfos = await Promise.all(compositionPromises);

                await deviceStore.sendHeterospermyBytesToFTPDevice(this.selectedRQId, requestInfos);
            }
            else {
                console.error("No RQ800 device found to process the request")
            }
        }
    }
})